import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import Quote from "../Widgets/Quote"
import CenterContainer from "../Widgets/CentredContentContainer"

class QuoteSlice extends PureComponent {

    render() {
        const {classes, item} = this.props;
        const {quote, quote_attribution} = item;

        return (
            <section>
                <CenterContainer>
                    <Quote bodyClassName={classes.quoteBody} quote={quote} quote_attribution={quote_attribution}/>
                </CenterContainer>
            </section>
        )
    }
}

export default injectSheet(
    {
        quoteBody: {
            maxWidth: 480,
            padding: 0,
            margin: [0, 'auto'],
            textAlign: "center",
            '& p': {
                marginBottom: 0
            }
        }
    }
)(QuoteSlice)





// WEBPACK FOOTER //
// ./src/components/Article/QuoteSlice.js